import { render, staticRenderFns } from "./AdminPanel.vue?vue&type=template&id=4fe3f2e2&scoped=true&"
import script from "./AdminPanel.vue?vue&type=script&lang=ts&"
export * from "./AdminPanel.vue?vue&type=script&lang=ts&"
import style0 from "./AdminPanel.vue?vue&type=style&index=0&id=4fe3f2e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe3f2e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTab,VTabItem,VTabs,VTabsItems,VTextField})
